import { styled, Typography } from '@mui/material';
import { ReactNode } from 'react';

const fontWeightMapping = {
    h2: 'bold',
    h3: 'normal',
};

function Section(props: {
    title: string;
    variant: 'h2' | 'h3';
    children: ReactNode;
    description?: string;
    subDescription?: string;
}) {
    const shouldAddBottomPadding = props.variant === 'h2';
    return (
        <Container shouldAddBottomPadding={shouldAddBottomPadding}>
            <Title variant={props.variant}>{props.title}</Title>
            {!!props.description && <Typography variant="body1">{props.description}</Typography>}
            {!!props.subDescription && (
                <Typography variant="body1">{props.subDescription}</Typography>
            )}
            <ChildrenContainer>{props.children}</ChildrenContainer>
        </Container>
    );
}

const Title = styled(Typography)(({ theme, variant }) => ({
    color: theme.palette.primary.main,
    fontWeight: fontWeightMapping[variant as 'h2' | 'h3'],
}));
const Container = styled('div')<{ shouldAddBottomPadding: boolean }>(
    ({ theme, shouldAddBottomPadding }) => ({
        flex: 1,
        paddingBottom: shouldAddBottomPadding ? theme.spacing(2) : 0,
    }),
);
const ChildrenContainer = styled('div')(({ theme }) => ({}));

export { Section };
